export class DocumentSupportImportModel {
    counter: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    enterpriseId: number = 0;
    bussinessDocumentsTypeCode: number = 0;
    consecutive: number = 0;
    dateDocumentSupport: Date = new Date();
    providerDocument: string = "";
    cuds: string | null = null;
    totalCreditNoteValue: number = 0;
    residueValue: number = 0;
    totalValue: number = 0;
    articleCode: number = 0;
    quantity: number = 0;
    unitValue: number = 0;
    creditNotesValue: number = 0;

    constructor(counter: number,
        companyId: number,
        branchId: number,
        enterpriseId: number,
        bussinessDocumentsTypeCode: number,
        consecutive: number,
        dateDocumentSupport: Date,
        providerDocument: string,
        cuds: string | null,
        totalCreditNoteValue: number,
        residueValue: number,
        totalValue: number,
        articleCode: number,
        quantity: number,
        unitValue: number,
        creditNotesValue: number,
    ) {
        this.counter = counter
        this.companyId = companyId;
        this.branchId = branchId;
        this.enterpriseId = enterpriseId;
        this.bussinessDocumentsTypeCode = bussinessDocumentsTypeCode;
        this.consecutive = consecutive;
        this.dateDocumentSupport = dateDocumentSupport;
        this.providerDocument = providerDocument;
        this.cuds = cuds;
        this.totalCreditNoteValue = totalCreditNoteValue;
        this.residueValue = residueValue;
        this.totalValue = totalValue;
        this.articleCode = articleCode;
        this.quantity = quantity;
        this.unitValue = unitValue;
        this.creditNotesValue = creditNotesValue;
    }
}